import './../src/App.css'
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from './store'
import AppRoutes from './routes/AppRoutes';
import 'react-image-crop/dist/ReactCrop.css';

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
